import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function FeiertagskontoDeactive({
  handleChange,
}: {
  handleChange: () => Promise<void>;
}) {
  const { t } = useTranslation();
  return (
    <Card className="p-4 gap-6 text-brand-blue-100 w-full">
      <CardHeader className="gap-2">
        <CardTitle>
          {t('domain.mitarbeiter.feiertagskonto.isDeactivated.titel')}
        </CardTitle>
        <CardDescription>
          {t('domain.mitarbeiter.feiertagskonto.isDeactivated.description')}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button
          variant="primary-pill"
          className="hidden md:block"
          onClick={handleChange}>
          {t('domain.mitarbeiter.feiertagskonto.isDeactivated.buttonLabel')}
        </Button>
        <div className="md:hidden">
          <Button
            variant="primary-pill"
            className="w-full"
            onClick={handleChange}>
            {t('domain.mitarbeiter.feiertagskonto.isDeactivated.buttonLabel')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
